export enum AggregateTypes {
  AVG = 'avg',
  SUM = 'sum',
  MAX = 'max',
  MIN = 'min',
  MODE = 'mode',
  COUNT = 'count',
  SAMPLE = 'sample',
  MEDIAN = 'median',
  GROUPCONCAT = 'group_concat',
  DISTINCTCOUNT = 'distinct_count',
  STANDARDDEVIATION = 'standard_deviation',
}

export type AggregateItemType =
  | typeof AggregateTypes.AVG
  | typeof AggregateTypes.SUM
  | typeof AggregateTypes.MIN
  | typeof AggregateTypes.MAX
  | typeof AggregateTypes.MODE
  | typeof AggregateTypes.COUNT
  | typeof AggregateTypes.SAMPLE
  | typeof AggregateTypes.MEDIAN
  | typeof AggregateTypes.GROUPCONCAT
  | typeof AggregateTypes.DISTINCTCOUNT
  | typeof AggregateTypes.STANDARDDEVIATION;

export type AggregateLabelsType = Record<AggregateItemType, string>;
